import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import EMTLevel from "../../components/emtLevel";
import MyLink from "../../components/myLink";
import Caution from "../../components/caution";
import Note from "../../components/note";
import PediatricNerveAgent from "../../data/tables/pediatricNerveAgent";
import PediatricAtropens from "../../data/tables/pediatricAtropens";
import AdultAutoInjectors from "../../data/tables/adultAutoInjectors";
import OrganophosphateTable from "../../data/tables/organophosphateTable";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <EMTLevel level="first-responder" mdxType="EMTLevel">
    <EMTLevel level="basic" mdxType="EMTLevel">
      <EMTLevel level="advanced" mdxType="EMTLevel">
        <ul>
          <li>
            <MyLink to="/sections/1/1.0-routine-patient-care" mdxType="MyLink">
              1.0 Routine Patient Care
            </MyLink>
          </li>
          <li>
            Assess for SLUDGEM (Salivation, Lacrimation, Urination, Defecation, Gastric
            upset, Emesis, Muscle twitching/miosis (constricted pupils) and KILLER Bs
            (Bradycardia, Bronchorrhea, Bronchospasm).
          </li>
          <li>Remove to cold zone after decontamination and monitor for symptoms.</li>
          <li>Antidotal therapy should be started as soon as symptoms appear.</li>
          <li>All antidote auto-injections must be administered IM.</li>
          <li>
            Determine dosing according to the following symptom assessment and guidelines.
          </li>
        </ul>
      </EMTLevel>
    </EMTLevel>
    </EMTLevel>
    <EMTLevel level="paramedic" mdxType="EMTLevel">
  <ul>
    <li>
      If field conditions permit, initiate cardiac monitoring and consider the
      administration of IV medications.
    </li>
    <li>If symptoms persist after the administration of 3 DuoDote kits:</li>
        <ul>
  <li>Atropine 2mg IV/IO; repeat every 5 minutes until secretions clear</li>
  <li>Pralidoxime 1 – 2 gram IV/IO over 30 – 60 minutes</li>
  <li>Diazepam 10mg IM by auto-injector every 10 minutes, as needed.</li>

Instead of diazepam, may use :

  <ul>
    <li>Midazolam 2 mg IV/IO/IN every 5 minutes; or 6 mg IM every 10 minutes</li>
  </ul>
        </ul>
  </ul>
    </EMTLevel>
    <EMTLevel level="paramedic" medControl={true} mdxType="EMTLevel">
  <ul>
    <li>
      Additional doses of above medications.
    </li>
    <li>
      Pralidoxime maintenance infusion: up to 500mg per hour (maximum of 12
      grams/day).
    </li>
  </ul>
    </EMTLevel>
    <Caution id="caution-1" mdxType="Caution">
  Do not administer an adult dose to a child &lt;50kg.
    </Caution>
    <Caution id="caution-2" mdxType="Caution">
  Dermal absorption of nerve agents may lead to delayed symptom
  onset up to 18 hours after exposure. Initial symptoms/signs may only be
  local such as localized fasiculations and sweating.
    </Caution>
    <Note id="note-1" mdxType="Note">
  <strong>PROCEDURES FOR SELF-CARE AND CARE OF AUTHORIZED PUBLIC EMPLOYEES
  OR FIRST RESPONDERS</strong>
  <ol style={{
        "textAlign": "left"
      }}>
    <li>Remove self or fellow authorized public employee from area if possible.</li>
    <li>Assess degree of symptoms: Mild, Moderate or Severe.</li>
    <li>
      Administer 1 to 3 auto-injector kits IM (each kit with atropine 2mg IM and pralidoxime chloride
      600mg IM) as guided by degree of symptoms.
    </li>
    <li>
      Seek additional medical support for further monitoring and transport of anyone receiving therapy.
    </li>
    <li>
      Disrobing will significantly enhance the decontamination process. Perform decontamination, and
      seek assistance in further decontamination measures.
    </li>
  </ol>
    </Note>
    <OrganophosphateTable mdxType="OrganophosphateTable" />
    <PediatricNerveAgent mdxType="PediatricNerveAgent" />
    <br />
    <PediatricAtropens mdxType="PediatricAtropens" />
    <br /> 
    <AdultAutoInjectors mdxType="AdultAutoInjectors" />
    <Note id="note-2" alignment="left" mdxType="Note">
  Mark I kits and Duodote are not approved for pediatric use, however, they should be used as
  initial therapy in circumstances for children with severe life-threatening nerve agent toxicity when IV
  therapy is not available. This assumes 0.8 inch needle insertion depth.
  <br /><br />
  Potential high dose of atropine and pralidoxime for age/weight. However, these numbers are
  within the general guidelines recommended for the first 60-90 minutes of therapy after a severe
  exposure.
  <br /><br />
  Administer injection in large muscle mass. Avoid deltoid. Suggest using thigh.
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      